import React from 'react'
import { Link } from 'react-router-dom'
import { Parallax } from 'react-scroll-parallax';

const FortyFive = () => (
  <div style={{ backgroundColor: 'black' }}>
  <div className="main-banner" style={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden'}}>
    <Parallax translateY={[-40, 40]}>
			<div className='radiothon-art' style={{ backgroundImage: 'url(/assets/4zzz45.png), url(/assets/bwcolor.png)',
			backgroundBlendMode: 'hard-light', width: 'calc(100vw - (100vw - 100%))', height: '100vh', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain, cover' }}>
      </div>
    </Parallax>
    </div>
    {/* <div class="main-para">

			<p>Thank you to all of the legendary listeners who joined the party this Radiothon and subscribed to 4ZZZ! Congrats on investing in what you believe in - local, independent media, arts and culture.</p>

			<p>If you've pledged this Radiothon, you have until Monday September 14 to pay up and be in the running for prizes. If you missed out on subscribing during Radiothon, there's still time! Subscribe before September 14 and you'll still go in the running for gold prizes - as well as category-specific prize draws too! So join the party and support 4ZZZ.</p>

    </div> */}
  </div>
)

export default FortyFive
